import { AppState } from '@/lib/store';
import Flow, { Chat } from '@/types/flow';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: DPreviewChat.PreviewChatState = {
  flowBuilderId: '',
  chat: [],
  isOpenProductList: false,
  isOpenYourCart: false,
  isOpenViewSentCart: false,
  isFromStart: false,
  catalogProductPreview: {
    catalog_id: '',
    products: [],
    text: '',
  },
  postProduct: {
    catalog_id: '',
    product_items: [],
    text: '',
  },
  viewSentCartData: {
    catalog_id: '',
    product_items: [],
    text: '',
  },
  isOpenListMenu: false,
  wa_list: {
    button: '',
    sections: [
      {
        title: '',
        rows: [
          {
            id: '',
            title: '',
            description: '',
          },
        ],
      },
    ],
    header: '',
    footer: '',
  },
  selectedList: {
    id: '',
    title: '',
    description: '',
  },
  timeoutId: null,
};

const previewChatSlice = createSlice({
  name: 'previewChat',
  initialState: initialState,
  reducers: {
    setOpenProductList: (state, action) => {
      state.isOpenProductList = action.payload;

      if (action.payload) {
        !state.isOpenYourCart;
      }
    },
    setOpenYourCart: (state, action) => {
      state.isOpenYourCart = action.payload;
    },
    setOpenViewSentCart: (state, action) => {
      state.isOpenViewSentCart = action.payload;
    },
    setIsFromStart: (state, action) => {
      state.isFromStart = action.payload;
    },
    unsetCatalogProductPreview: (state) => {
      state.catalogProductPreview = {
        catalog_id: '',
        products: [],
        text: '',
      };

      state.postProduct = {
        catalog_id: '',
        product_items: [],
        text: '',
      };
    },
    setCatalogProductPreview: (state, action) => {
      state.catalogProductPreview = action.payload;
    },
    setCatalogProductPost: (
      state,
      action: PayloadAction<{
        catalog_id: string;
        text: string;
        retailerId: string;
        actions: 'add' | 'subtract';
        currency: string;
        imageUrl: string;
        name: string;
        price: string;
      }>
    ) => {
      const {
        catalog_id,
        text,
        actions,
        retailerId,
        currency,
        imageUrl,
        name,
        price,
      } = action.payload;

      const check = state.postProduct.product_items.findIndex(
        (value) => value.retailerId === retailerId
      );

      state.postProduct.catalog_id = catalog_id;
      state.postProduct.text = text;

      if (check !== -1) {
        if (actions === 'add') {
          state.postProduct.product_items[check].quantity += 1;
        } else if (
          actions === 'subtract' &&
          state.postProduct.product_items[check].quantity > 1
        ) {
          state.postProduct.product_items[check].quantity -= 1;
        } else {
          state.postProduct.product_items.splice(check, 1);
        }
      } else {
        state.postProduct.product_items.push({
          quantity: 1,
          retailerId: retailerId,
          currency,
          imageUrl,
          name,
          price,
        });
      }
    },
    setViewSentCartData: (state, action) => {
      state.viewSentCartData = action.payload;
    },
    setOpenListMenu: (state, action) => {
      state.isOpenListMenu = action.payload;
    },
    setListMenu: (state, action) => {
      state.wa_list = action.payload;
    },
    setSelectedList: (state, action) => {
      state.selectedList = action.payload;
    },
    setTimeoutId: (state, action) => {
      state.timeoutId = action.payload;
    },
  },
});

export const {
  setOpenProductList,
  setOpenYourCart,
  unsetCatalogProductPreview,
  setCatalogProductPreview,
  setCatalogProductPost,
  setOpenViewSentCart,
  setViewSentCartData,
  setIsFromStart,
  setOpenListMenu,
  setListMenu,
  setSelectedList,
  setTimeoutId,
} = previewChatSlice.actions;

export const selectPreviewChat = (state: AppState) => state.previewChat;

export default previewChatSlice.reducer;
